// Filets des sections éditoriales : tracés quand l'élément entre à l'écran.
(() => {
  const selector = '.mr-ed, .mr-ed__ruled, .mr-ed__detail-grid article, .mr-ed__material-list, .mr-ed__steps, .mr-ed__fact, .mr-ed details';
  const reveal = (element) => element.classList.add('is-lined');
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll(selector).forEach(reveal);
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      reveal(entry.target);
      observer.unobserve(entry.target);
    }
  }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
  const init = (root = document) => root.querySelectorAll(selector).forEach((element) => {
    if (element.dataset.edLines) return;
    element.dataset.edLines = 'true';
    // Accordéons (matières, questions) : les filets se tracent en cascade de haut
    // en bas, une fois le filet vertical de la liste parti.
    if (element.tagName === 'DETAILS') {
      const index = [...element.parentElement.children].indexOf(element);
      element.style.setProperty('--ed-line-delay', `${0.25 + index * 0.12}s`);
    }
    observer.observe(element);
  });
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
